export const ScrollBus = {
  callbacks: new Set(),

  emit(scroll) {
    this.callbacks.forEach(cb => cb(scroll));
  },

  on(cb) {
    this.callbacks.add(cb);
    return () => this.callbacks.delete(cb);
  },
};
